import SectionLabel from "./SectionLabel";
import { FadeUp, MaskLine } from "./Reveal";

const outcomes = [
  "Your current position",
  "The questions you still need answered",
  "The intelligence you need to gather",
  "What Heaven may be saying",
  "Relationships worth pursuing",
  "Resources and opportunities you may need to explore",
  "What requires further investigation",
  "The next move that deserves your attention",
];

export default function Outcome() {
  return (
    <section data-testid="outcome-section" className="bg-blush text-ink">
      <div className="mx-auto max-w-7xl px-6 py-28 md:px-10 md:py-40">
        <div className="flex items-start justify-between">
          <SectionLabel testid="outcome-label">Mission Outcome</SectionLabel>
          <FadeUp delay={0.2}>
            <img
              src="/assets/wmwe-logo-dark.png"
              alt="WMWE — Run to the Table"
              data-testid="outcome-logo"
              className="h-16 w-16 object-contain md:h-20 md:w-20"
            />
          </FadeUp>
        </div>

        <h2 className="max-w-3xl font-serif text-4xl font-medium leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
          <MaskLine>You won't leave with</MaskLine>
          <MaskLine delay={0.1}>
            <span className="italic text-wine">just inspiration.</span>
          </MaskLine>
        </h2>

        <FadeUp delay={0.2} className="mt-8">
          <p className="font-sans text-[11px] tracking-[0.35em] text-ink/50">
            YOU WILL LEAVE WITH GREATER CLARITY AROUND:
          </p>
        </FadeUp>

        <div className="mt-12 grid gap-px border border-ink/15 bg-ink/15 md:grid-cols-2">
          {outcomes.map((o, i) => (
            <FadeUp key={o} delay={i * 0.05}>
              <div
                data-testid={`outcome-item-${i + 1}`}
                className="group flex h-full items-baseline gap-5 bg-blush p-7 transition-colors duration-300 hover:bg-[#FFD3C4]"
              >
                <span className="font-sans text-wine transition-transform duration-300 group-hover:translate-x-1.5">
                  →
                </span>
                <p className="text-base text-ink/85 md:text-lg">{o}</p>
              </div>
            </FadeUp>
          ))}
        </div>

        <FadeUp delay={0.3} className="mt-20 md:ml-auto md:max-w-3xl">
          <p className="font-serif text-3xl italic leading-snug text-ink md:text-4xl">
            Because the goal isn't to leave knowing everything. It's to leave knowing{" "}
            <span className="text-wine">what you need to know next.</span>
          </p>
        </FadeUp>
      </div>
    </section>
  );
}
